<template>
  <div>
    <Row :gutter="10">
      <i-col :md="24" :lg="24" style="margin-bottom: 10px;">
        <Card>
          <Alert banner closable>搜索支持全局搜索，多条件搜索时请使用“|”作为条件分隔符</Alert>
          <div class="search-con search-con-top">
            <Input class="search-input" v-model="searchVal" style="padding:5px;" placeholder="输入关键字全局搜索"
                   @on-enter="searchinput"/>
            <slot name="new_btn">
              <Button type="primary" @click="editModal('', 'post', '新增')" class="search-btn">新增</Button>
            </slot>
            <Button type="error" class="search-btn" @click="handlerDelete">批量删除</Button>
          </div>
          <Spin size="large" fix v-if="spinShow"></Spin>
          <Table v-loading.fullscreen.lock="fullscreenLoading" height="670" size="small" ref="selection" border
                 :columns="columns" :data="tableData"
                 @on-selection-change="handleSelectChange"></Table>
          <div style="margin: 10px; overflow: hidden">
            <div style="float: left;">
              <Page :total="pageTotal" :current="pageNum" :page-size="pageSize" :page-size-opts=[15,35,50,100]
                    show-sizer show-total @on-change="changePage" @on-page-size-change="handlePageSize">
              </Page>
            </div>
          </div>
          <Modal v-model="modalMap.modalVisible" :title="modalMap.modalTitle" :loading=true :footer-hide=true
                 :mask-closable=false>
            <Form ref="formValidate" :model="formValidate" :rules="ruleValidate" :label-width="100">
              <FormItem
                label="姓名"
                prop="name"
              >
                <Input
                  v-model="formValidate.name"
                  placeholder="请输入姓名"
                ></Input>
              </FormItem>
              <FormItem
                label="证件号码"
                prop="idcard"
              >
                <Input
                  v-model="formValidate.idcard"
                  placeholder="请输入证件号码"
                ></Input>
              </FormItem>
              <FormItem
                label="证件类型"
                prop="cardtype"
              >
                <el-select
                  v-model="formValidate.cardtype"
                  filterable
                  allow-create
                  default-first-option
                  placeholder="请选择证件类型">
                  <el-option
                    v-for="item in cardtypeList"
                    :key="item.value"
                    :label="item.meaning"
                    :value="parseInt(item.value)">
                  </el-option>
                </el-select>
              </FormItem>
              <FormItem
                label="联系电话"
                prop="phone"
              >
                <Input
                  v-model="formValidate.phone"
                  placeholder="请输入联系电话"
                ></Input>
              </FormItem>
              <FormItem
                label="联系地址"
                prop="address"
              >
                <Input
                  v-model="formValidate.address"
                  placeholder="请输入联系地址"
                ></Input>
              </FormItem>
              <FormItem
                label="就业状态"
                prop="estatus"
              >
                <el-select
                  v-model="formValidate.estatus"
                  filterable
                  default-first-option
                  allow-create
                  placeholder="请选择就业状态">
                  <el-option
                    v-for="item in estatusList"
                    :key="item.value"
                    :label="item.meaning"
                    :value="parseInt(item.value)">
                  </el-option>
                </el-select>
              </FormItem>
              <FormItem
                label="就业单位"
                prop="company"
              >
                <Input
                  v-model="formValidate.company"
                  placeholder="请输入就业单位"
                ></Input>
              </FormItem>
              <FormItem
                label="人员状态"
                prop="pstatus"
              >
                <el-select
                  v-model="formValidate.pstatus"
                  filterable
                  default-first-option
                  allow-create
                  placeholder="请选择人员状态">
                  <el-option
                    v-for="item in pstatusList"
                    :key="item.value"
                    :label="item.meaning"
                    :value="parseInt(item.value)">
                  </el-option>
                </el-select>
              </FormItem>
              <FormItem
                label="就业类型"
                prop="etype"
              >
                <el-select
                  v-model="formValidate.etype"
                  filterable
                  default-first-option
                  allow-create
                  placeholder="请选择就业类型">
                  <el-option
                    v-for="item in etypeList"
                    :key="item.value"
                    :label="item.meaning"
                    :value="parseInt(item.value)">
                  </el-option>
                </el-select>
              </FormItem>
              <FormItem>
                <Button
                  type="primary"
                  @click="handleSubmit('formValidate')"
                >提交
                </Button>
                <Button
                  @click="handleReset('formValidate')"
                  style="margin-left: 8px"
                >重置
                </Button>
              </FormItem>
            </Form>
          </Modal>
        </Card>
      </i-col>
    </Row>
  </div>
</template>
<script>

import {
  getWorkforceinfolist,
  operationWorkforceinfo
} from '@/api/workforce/workforceinfo.js'
import {getsysparameterList} from '@/api/system/sys_parameter'

let moment = require('moment')
export default {
  data () {
    return {
      spinShow: false,
      fullscreenLoading: false,
      cardtypeList: [],
      estatusList: [],
      pstatusList: [],
      etypeList: [],
      formValidate: {},
      searchVal: '',
      tableData: [],
      modalMap: {
        modalVisible: false,
        modalTitle: '新建'
      },
      tableSelectIdList: [],
      editModalData: '',
      pageNum: 1, // 当前页码
      pageTotal: 0, // 数据总数
      pageSize: 15, // 每页条数

      ruleValidate: {
        name: [
          {
            required: true,
            message: '姓名不能为空',
            trigger: 'blur'
          }
        ],
        idcard: [
          {
            required: true,
            message: '证件号码不能为空',
            trigger: 'blur'
          }
        ],
        cardtype: [
          {
            required: true,
            message: '请选择证件类型',
            trigger: 'change'
          }
        ],
        phone: [
          {
            required: true,
            message: '联系电话不能为空',
            trigger: 'blur'
          }
        ],
        address: [
          {
            required: true,
            message: '联系地址不能为空',
            trigger: 'blur'
          }
        ],
        estatus: [
          {
            required: true,
            message: '请选择就业状态',
            trigger: 'change'
          }
        ],
        pstatus: [
          {
            required: true,
            message: '请选择人员状态',
            trigger: 'change'
          }
        ],
        etype: [
          {
            required: true,
            message: '请选择就业类型',
            trigger: 'change'
          }
        ]
      },
      columns: [
        {
          type: 'selection',
          key: 'id',
          width: 60,
          fixed: 'left',
          align: 'center'
        },
        {
          title: '姓名',
          key: 'name',
          width: 120,
          tooltip: true,
          align: 'center',
          sortable: true },
        {
          title: '证件号码',
          key: 'idcard',
          width: 200,
          tooltip: true,
          align: 'center',
          sortable: true },
        {
          title: '证件类型',
          key: 'cardtype_CN',
          width: 120,
          tooltip: true,
          align: 'center',
          sortable: true },
        {
          title: '联系电话',
          key: 'phone',
          width: 120,
          tooltip: true,
          align: 'center',
          sortable: true },
        {
          title: '联系地址',
          key: 'address',
          tooltip: true,
          align: 'center',
          sortable: true },
        {
          title: '就业状态',
          key: 'estatus_CN',
          width: 120,
          tooltip: true,
          align: 'center',
          sortable: true },
        {
          title: '就业单位',
          key: 'company',
          width: 250,
          tooltip: true,
          align: 'center',
          sortable: true },
        {
          title: '人员状态',
          key: 'pstatus_CN',
          width: 120,
          tooltip: true,
          align: 'center',
          sortable: true },
        {
          title: '就业类型',
          key: 'etype_CN',
          width: 120,
          tooltip: true,
          align: 'center',
          sortable: true },
        {
          title: '操作',
          key: 'handle',
          fixed: 'right',
          width: 180,
          align: 'center',
          render: (h, params) => {
            return h('div', [
              h(
                'Button',
                {
                  props: {
                    type: 'primary',
                    size: 'small'
                  },
                  style: {
                    marginRight: '5px'
                  },
                  on: {
                    click: () => {
                      this.editModal(params.row, 'post', '修改')
                    }
                  }
                },
                '编辑'
              ),
              h(
                'Button',
                {
                  props: {
                    type: 'error',
                    size: 'small'
                  },
                  on: {
                    click: () => {
                      this.delData(params)
                    }
                  }
                },
                '删除'
              )
            ])
          }
        }
      ]
    }
  },
  methods: {
    getWorkforceinfolist (key, value) {
      this.spinShow = true
      getWorkforceinfolist(this.pageNum, this.pageSize, key, value).then(res => {
        if (res.data.code === 0) {
          this.pageTotal = res.data.count
          this.tableData = res.data.data
        } else {
          this.$Message.error(`${res.data.msg}`)
        }
        this.spinShow = false
      })
    },
    getParameterList () {
      getsysparameterList('workforce_info', 'cardtype').then(res => {
        if (res.data.code === 0) {
          this.cardtypeList = res.data.data
        } else {
          this.$Message.error(`${res.data.msg}`)
        }
      })
      getsysparameterList('workforce_info', 'estatus').then(res => {
        if (res.data.code === 0) {
          this.estatusList = res.data.data
        } else {
          this.$Message.error(`${res.data.msg}`)
        }
      })
      getsysparameterList('workforce_info', 'pstatus').then(res => {
        if (res.data.code === 0) {
          this.pstatusList = res.data.data
        } else {
          this.$Message.error(`${res.data.msg}`)
        }
      })
      getsysparameterList('workforce_info', 'etype').then(res => {
        if (res.data.code === 0) {
          this.etypeList = res.data.data
        } else {
          this.$Message.error(`${res.data.msg}`)
        }
      })
    },
    handleSelectChange (val) {
      let SelectIdList = []
      val.forEach(item => {
        SelectIdList.push(item.id)
      })
      this.tableSelectIdList = SelectIdList
    },
    closeModal () {
      this.dialog.show = false
    },
    editModal (paramsRow, meth, mtitle) {
      this.modalMap.modalVisible = true
      this.modalMap.modalTitle = mtitle
      this.editModalData = meth
      this.getParameterList()
      var day2 = new Date()
      day2.setTime(day2.getTime())
      var s2 = day2.getFullYear() + '-' + (day2.getMonth() + 1) + '-' + day2.getDate() + ' ' + day2.getHours() + ':' + day2.getMinutes() + ':' + day2.getSeconds()
      if (paramsRow && paramsRow.id) {
        this.formValidate = {
          id: paramsRow.id,
          name: paramsRow.name,
          idcard: paramsRow.idcard,
          cardtype: paramsRow.cardtype,
          phone: paramsRow.phone,
          address: paramsRow.address,
          estatus: paramsRow.estatus,
          company: paramsRow.company,
          pstatus: paramsRow.pstatus,
          etype: paramsRow.etype
        }
      } else {
        this.formValidate = {
          id: 0,
          name: '',
          idcard: '',
          cardtype: '',
          phone: '',
          address: '',
          estatus: '',
          company: '',
          pstatus: '',
          etype: ''
        }
      }
    },
    handleSubmit (value) {
      this.$refs[value].validate((valid) => {
        if (valid) {
          setTimeout(() => {
            operationWorkforceinfo(this.formValidate, this.editModalData).then(res => {
              if (res.data.code === 0) {
                this.$Message.success(`${res.data.msg}`)
                if (this.searchVal) {
                  this.getWorkforceinfolist(this.searchVal)
                } else {
                  this.getWorkforceinfolist()
                }
                this.modalMap.modalVisible = false
              } else {
                this.$Message.error(`${res.data.msg}`)
              }
            })
          }, 1000)
        } else {
          this.$Message.error('缺少必要参数')
        }
      })
    },
    handleReset (name) {
      this.$refs[name].resetFields()
    },
    handlerDelete () {
      if (this.tableSelectIdList.length > 0) {
        if (confirm(`确定要批量删除选中数据嘛？ `)) {
          operationWorkforceinfo({'id_list': this.tableSelectIdList}, 'delete').then(res => {
              if (res.data.code === 0) {
                this.$Message.success(`${res.data.msg}`)
                this.getWorkforceinfolist(this.searchVal)
              } else {
                this.$Message.error(`${res.data.msg}`)
              }
            })
        }
      } else {
        this.$Message.info(`你总要选中点什么吧`)
      }
    },
    delData (params) {
      if (confirm(`确定要删除该信息吗？`)) {
        operationWorkforceinfo(
          {
            'id': params.row.id
          },
          'delete'
        ).then(res => {
          if (res.data.code === 0) {
            this.$Message.success(`${res.data.msg}`)
            this.tableData.splice(params.index, 1)
          } else {
            this.$Message.error(`${res.data.msg}`)
          }
        })
      }
    },
    changePage (value) {
      this.pageNum = value
      if (this.searchVal) {
        this.getWorkforceinfolist(this.searchVal)
      } else {
        this.getWorkforceinfolist()
      }
    },
    handlePageSize (value) {
      this.pageSize = value
      this.pageNum = 1
      if (this.searchVal) {
        this.getWorkforceinfolist(this.searchVal)
      } else {
        this.getWorkforceinfolist()
      }
    },
    searchinput () {
      if (this.searchVal) {
        this.getWorkforceinfolist(this.searchVal)
      } else {
        this.getWorkforceinfolist()
      }
    }
  },
  watch: {
    searchVal (val) {
      this.searchVal = val
    }
  },
  mounted () {
    this.getWorkforceinfolist()
  }
}
</script>
<style lang="less" scoped>
.search-con {
  padding: 10px 0;
  .search {
    &-col {
      display: inline-block;
      width: 200px;
    }
    &-input {
      display: inline-block;
     width: 200px;
      margin-left: 2px;
    }
    &-btn {
      margin-left: 2px;
    }
  }
}
</style>
